module.exports = __webpack_public_path__ + "static/11-24e7b625753b30988a0fcdba97980cd1.jpg";